import { DocumentType } from '@/enums/DocumentType'

// A PDF field's flags are a bit field; the second bit marks the field as required.
export const PdfFieldFlag = {
	Required: 2,
} as const

export type RequiredTextField = { name: string; label: string }

export const requiredCheckBoxFieldsConfig: Partial<
	Record<DocumentType, { regex: RegExp; name: string }[]>
> = {
	[DocumentType.EnrollmentForm]: [
		{
			regex: /paymentMode\w*Check/,
			name: 'Payment Mode Checkboxes',
		},
		{
			regex: /payment\w*PayCheck/,
			name: 'Payment Term Checkboxes',
		},
		{
			regex: /healthQuestions1\w*/,
			name: 'Health Question 1',
		},
		{
			regex: /applicantReplacement1\w*/,
			name: 'Applicant Replacement 1',
		},
		{
			regex: /applicantReplacement2\w*/,
			name: 'Applicant Replacement 2',
		},
		{
			regex: /applicantReplacement\w*/,
			name: 'Applicant Replacement',
		},
		{
			regex: /agentReplacement1\w*/,
			name: 'Agent Replacement 1',
		},
		{
			regex: /agentReplacement2\w*/,
			name: 'Agent Replacement 2',
		},
		{
			regex: /agentReplacement\w*/,
			name: 'Agent Replacement',
		},
		{
			regex: /producerReplacement\w*/,
			name: 'Producer Replacement',
		},
		{
			regex: /applicantExistingPreneed\w*Check/,
			name: 'Applicant Existing Preneed',
		},
		{
			regex: /applicantPreneedReplacement\w*Check/,
			name: 'Applicant Preneed Replacement',
		},
	],
}

// Text fields that Sales Studio requires in every state, whether or not the PDF
// itself flags them as required. The label is what the validation modal lists,
// since these fields do not reliably carry an alternate name in the PDF.
export const requiredTextFieldsConfig: Partial<
	Record<DocumentType, RequiredTextField[]>
> = {
	[DocumentType.EnrollmentForm]: [
		{
			name: 'funeralHomeRepresentativeProducerNumber',
			label: 'Producer Number',
		},
	],
}

export const useDefaultRequiredFieldsProvider = () => {
	const getRequiredCheckBoxConfig = (documentType: DocumentType) => {
		// Copied so state providers can append to it without mutating the config
		return [...(requiredCheckBoxFieldsConfig[documentType] ?? [])]
	}

	const getRequiredTextFieldConfig = (
		documentType: DocumentType | undefined
	): RequiredTextField[] => {
		return documentType ? (requiredTextFieldsConfig[documentType] ?? []) : []
	}

	// Fields whose required flag is set on the PDF form when a document is opened
	const getRequiredFieldsConfig = (
		documentType: DocumentType | undefined
	): { name: string; flag: number }[] => {
		return getRequiredTextFieldConfig(documentType).map(({ name }) => ({
			name,
			flag: PdfFieldFlag.Required,
		}))
	}

	return {
		getRequiredCheckBoxConfig,
		getRequiredTextFieldConfig,
		getRequiredFieldsConfig,
	}
}
